export interface IScoreboardStatsEntry {
  numberOfStudents: number;
  completedKilometers: number;
  carbonDioxide: number;
}

export interface IScoreboardStats {
  totalStudents: number;
  totalKilometers: number;
  totalCarbonDioxide: number;
}

export default class ScoreboardHelper {
  public static calculateStats(entries: IScoreboardStatsEntry[] | undefined): IScoreboardStats | null {
    if (!entries) {
      return null;
    }

    return entries.reduce(
      (totals, participation) => ({
        totalStudents: totals.totalStudents + participation.numberOfStudents,
        totalKilometers: totals.totalKilometers + participation.completedKilometers,
        totalCarbonDioxide: totals.totalCarbonDioxide + participation.carbonDioxide,
      }),
      {
        totalStudents: 0,
        totalKilometers: 0,
        totalCarbonDioxide: 0,
      },
    );
  }
}
